export default "__VITE_PUBLIC_ASSET__8811c54d__"